import * as React from "react";
import {compose} from "redux";
import {createStyles, Theme, withStyles, WithStyles} from "@material-ui/core";
import Icon from "@material-ui/core/Icon/Icon";
import Fade from "@material-ui/core/Fade/Fade";
import {css} from 'src/conf/style'

const styles = (t: Theme) => createStyles({
  root: {
    ...css.flexAlCenter,
    margin: `${t.spacing.unit}px 0`
  },
  text: {
    paddingLeft: t.spacing.unit
  },
  icon: {
    fontSize: 20
  }
});

interface IProps extends WithStyles<typeof styles> {
  isValid: boolean;
  label: string;
}

class LabelValidation extends React.Component<IProps, {}>{

  render() {
    const { classes, isValid, label } = this.props;
    return (
      <div className={classes.root}>
        {!isValid &&
        <Fade in={!isValid}>
          <Icon
            color='error'
            className={classes.icon}
          >
            error
          </Icon>
        </Fade>
        }


        {isValid &&
        <Fade in={isValid}>
          <Icon
            style={{color: 'green'}}
            className={classes.icon}
          >
            check_circle
          </Icon>
        </Fade>
        }
        <span className={classes.text}>{label}</span>
      </div>
    )
  }

}

export default compose(
  withStyles(styles)
)(LabelValidation);



// WEBPACK FOOTER //
// ./src/shared/LabelValidation/LabelValidation.tsx